const n = "_featuredIconContainer_hccq4_1", t = "_lg_hccq4_4", e = "_md_hccq4_10", c = "_sm_hccq4_16", _ = "_xs_hccq4_22", l = "_tintedNeutral_hccq4_28", i = "_tintedBrand_hccq4_31", o = "_tintedDanger_hccq4_34", d = "_tintedWarning_hccq4_37", s = "_tintedSuccess_hccq4_40", a = "_tintedInfo_hccq4_43", r = "_filledNeutral_hccq4_46", u = "_filledBrand_hccq4_49", f = "_filledDanger_hccq4_52", h = "_filledWarning_hccq4_55", q = "_filledSuccess_hccq4_58", g = "_filledInfo_hccq4_61", I = "_outlineNeutral_hccq4_64", B = "_outlineBrand_hccq4_67", D = "_outlineDanger_hccq4_70", N = "_outlineWarning_hccq4_73", S = "_outlineSuccess_hccq4_76", W = "_outlineInfo_hccq4_79", m = {
  featuredIconContainer: n,
  lg: t,
  md: e,
  sm: c,
  xs: _,
  tintedNeutral: l,
  tintedBrand: i,
  tintedDanger: o,
  tintedWarning: d,
  tintedSuccess: s,
  tintedInfo: a,
  filledNeutral: r,
  filledBrand: u,
  filledDanger: f,
  filledWarning: h,
  filledSuccess: q,
  filledInfo: g,
  outlineNeutral: I,
  outlineBrand: B,
  outlineDanger: D,
  outlineWarning: N,
  outlineSuccess: S,
  outlineInfo: W
};
export {
  m as default,
  n as featuredIconContainer,
  u as filledBrand,
  f as filledDanger,
  g as filledInfo,
  r as filledNeutral,
  q as filledSuccess,
  h as filledWarning,
  t as lg,
  e as md,
  B as outlineBrand,
  D as outlineDanger,
  W as outlineInfo,
  I as outlineNeutral,
  S as outlineSuccess,
  N as outlineWarning,
  c as sm,
  i as tintedBrand,
  o as tintedDanger,
  a as tintedInfo,
  l as tintedNeutral,
  s as tintedSuccess,
  d as tintedWarning,
  _ as xs
};
//# sourceMappingURL=FeaturedIcon.module.scss.js.map
